<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Code" prop="code">
        <a-input v-model="form.code" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Title" prop="title">
        <a-input v-model="form.title" placeholder="Enter text" />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAddDocumentType" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button
        type="primary"
        @click="createDocumentType()"
        :loading="iconLoading"
      >
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import postQuery from "../../data/postData";
export default {
  props: {
    closeDrawerAddDocumentType: {
      type: Function,
      default: null,
    },
    createdDocumentTypeOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        code: null,
        title: null,
      },
      rules: {
        code: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
          {
            min: 1,
            message: "Code must not be less than 1 characters",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    createDocumentType() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreateDocumentType,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createDocumentType) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Thêm loại công văn thành công !",
                });

                this.createdDocumentTypeOnView(data.createDocumentType);
              }
              this.iconLoading = false;
              this.closeDrawerAddDocumentType();
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Thêm loại công văn không thành công !" + error,
              });
              console.log("Không lấy được danh sách loại công văn", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style></style>
